export default "__VITE_ASSET__cce1e80b__"